<template>
  <login-wrap
    id="loginPin"
    :text="text">
    <valid-form @submit="loginAction">
      <qx-input-row
        id="codePin"
        v-model="code"
        :aria-label="codePlaceholderText"
        :label="codePlaceholderText"
        :autofocus="true"
        rules="required|digits:5"
        name="pin"
        :trim="true" />
      <qx-button
        id="login-pin"
        :title="loginButtonLabel"
        :is-block="true"
        :in-progress="inProgress"
        type="submit"
        state="active" />
    </valid-form>
    <another-account v-if="!isPublicShare" />
  </login-wrap>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { Form as ValidForm } from 'vee-validate';

import QxInputRow from '@/elements/QxInputRow.vue';
import anotherAccount from '@/elements/auth/anotherAccount.vue';
import qxButton from '@/elements/button.vue';
import LoginWrap from '@/components/auth/LoginWrap.vue';

import { btoa } from '@/elements/utils.js';
import { mfaLogin, sharePin } from '@/api';

export default {
  name: 'LoginPin',
  components: {
    QxInputRow,
    anotherAccount,
    qxButton,
    LoginWrap,
    ValidForm,
  },
  emits: ['successLogin'],
  data() {
    return {
      inProgress: false,
      code: '',
      codePlaceholderText: this.$gettext('Security PIN'),
      loginButtonLabel: this.$gettext('Log in'),
    };
  },
  computed: {
    ...mapState({
      isStandAlonePage: (state) => state.isStandAlonePage,
    }),
    isPublicShare() {
      return this.$store.state.downloadPage.welcome.share_type === 'P';
    },
    isKeyRequest() {
      return this.$route?.name === 'key-request';
    },
    text() {
      return this.isStandAlonePage && !this.isKeyRequest
        ? this.$gettext('Enter security PIN for this share')
        : this.$gettext('Enter your personal security PIN');
    },
  },
  methods: {
    ...mapMutations({
      setLoginError: 'auth/setLoginError',
    }),
    async loginAction() {
      if (this.inProgress) {
        return;
      }
      this.inProgress = true;
      const pin = this.code;
      try {
        if (this.isStandAlonePage && !this.isKeyRequest) {
          await sharePin({
            id: this.$route.params.id,
            pin: btoa(this.code),
          });
          this.$emit('successLogin');
        } else {
          const { status } = await mfaLogin({
            auth_type: 'PIN',
            code: this.code,
          });
          if (status === 200) {
            this.$emit('successLogin');
          }
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          this.setLoginError('wrongPin');
        }
      } finally {
        this.inProgress = false;
      }
    },
  },
};
</script>
